var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 14.2188H5.625C2.23125 14.2188 0.78125 12.7688 0.78125 9.375V5.625C0.78125 2.23125 2.23125 0.78125 5.625 0.78125H8.75C9.00625 0.78125 9.21875 0.99375 9.21875 1.25C9.21875 1.50625 9.00625 1.71875 8.75 1.71875H5.625C2.74375 1.71875 1.71875 2.74375 1.71875 5.625V9.375C1.71875 12.2563 2.74375 13.2812 5.625 13.2812H9.375C12.2563 13.2812 13.2812 12.2563 13.2812 9.375V6.25C13.2812 5.99375 13.4937 5.78125 13.75 5.78125C14.0063 5.78125 14.2188 5.99375 14.2188 6.25V9.375C14.2188 12.7688 12.7688 14.2188 9.375 14.2188Z",
    fill: "#545454"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 6.7188H11.25C9.1125 6.7188 8.28125 5.88755 8.28125 3.75005V1.25005C8.28125 1.06255 8.39375 0.887554 8.56875 0.818804C8.74375 0.743804 8.94375 0.787554 9.08125 0.918804L14.0813 5.9188C14.2125 6.05005 14.2563 6.2563 14.1813 6.4313C14.1063 6.6063 13.9375 6.7188 13.75 6.7188ZM9.21875 2.3813V3.75005C9.21875 5.36255 9.6375 5.7813 11.25 5.7813H12.6188L9.21875 2.3813Z",
    fill: "#545454"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.125 8.59375H4.375C4.11875 8.59375 3.90625 8.38125 3.90625 8.125C3.90625 7.86875 4.11875 7.65625 4.375 7.65625H8.125C8.38125 7.65625 8.59375 7.86875 8.59375 8.125C8.59375 8.38125 8.38125 8.59375 8.125 8.59375Z",
    fill: "#545454"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 11.0938H4.375C4.11875 11.0938 3.90625 10.8813 3.90625 10.625C3.90625 10.3688 4.11875 10.1562 4.375 10.1562H6.875C7.13125 10.1562 7.34375 10.3688 7.34375 10.625C7.34375 10.8813 7.13125 11.0938 6.875 11.0938Z",
    fill: "#545454"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentText);
export default __webpack_public_path__ + "static/media/document-text.3d3b1b34aabbd711a79fbccb345c1098.svg";
export { ForwardRef as ReactComponent };